import { Button, Stack, Typography } from "@mui/material";

const GenericNotFound = () => {
  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{
        alignItems: "center",
        marginTop: 2,
        paddingBottom: 2,
      }}
    >
      <Typography variant="h1">404</Typography>
      <Typography variant="h4">Nie znaleziono strony</Typography>
      <Button color="primary" variant="contained" href="/">
        Przejdź do strony głównej
      </Button>
    </Stack>
  );
};

export default GenericNotFound;
